import {
  PERSONAL_TRUSTPASS_STATUS_UPDATE,
  PERSONAL_TRUSTPASS_DOCUMENT_UPDATE,
} from '../actionTypes';

let initialState = {
  requirements: [
    {
      identifier: 'personal_information',
      object: null,
      status: null,
    },
    {
      identifier: 'personal_credit_check',
      object: null,
      status: null,
    },
  ],
  submitted_at: null,
}

export default function personal(state = initialState, action) {
  switch(action.type) {
    case 'USER_RECEIVE_DETAILS_AND_TOKEN': // TODO: move this properly later
      if(!action.payload.active_personal_trustpass) return state;

      return action.payload.active_personal_trustpass;
    case PERSONAL_TRUSTPASS_DOCUMENT_UPDATE:
      if(!state || !state.requirements) return state;
      const updatedDoc = action.payload;
      let newRequirements = state.requirements.map((requirement) => {
        if (requirement.identifier === updatedDoc.identifier) {
          return {...requirement, object: updatedDoc.object}
        }
        return requirement;
      })

      return {...state, requirements: newRequirements}
    case PERSONAL_TRUSTPASS_STATUS_UPDATE:
      let submittedDate = Date.now();
      let requirements = (!state || !state.requirements) ? state.requirements : initialState.requirements;
      let updatedRequirements = requirements.map((requirement) => {
        return { ...requirement, status: action.payload }
      })

      return {...state, requirements: updatedRequirements, submitted_at: submittedDate};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/trustpass/reducers/personal.js